module.exports = __webpack_public_path__ + "media/images/riders/small/VICTOR_KORETZKY-cf75194eb29226d491f6ee810ce02847.png";